<template>
  <div class="home">
    <b-container class="container-rda sidebar">
      <b-row class="height">
        <sidebar-coordination />
        <b-col class="content">
          <b-row>
            <b-col>
              <Breadcrumb :breadcrumb="breadcrumb" />
            </b-col>
          </b-row>

          <b-row class="mb-4">
            <b-col>
              <h2 class="purple bold">Mensalidade escolar</h2>
            </b-col>
          </b-row>

          <b-row class="mb-4">
            <b-col>
              <SelectSingle
                label="Selecionar calendário"
                :options="calendars"
                :callback="handleCalendar"
                :initial="selectedCalendar"
              />
            </b-col>
          </b-row>

          <b-tabs v-model="activeTab" content-class="mt-3" class="pititim-tabs">
            <!-- Tab: Mensalidade Escolar -->
            <b-tab title="Mensalidade Escolar">
              <b-row class="mb-3 mt-3">
                <b-col class="text-right">
                  <b-button
                    class="btn large blue"
                    :to="{
                      name: 'mensalidade-escolar-registrar',
                      query: { calendar: selectedCalendar ? selectedCalendar.id : '' },
                    }"
                    >Registrar novos preços</b-button
                  >
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <DataTable
                    :items="prices"
                    :fields="tableFields"
                    :busy="!isRequestSend"
                    empty-text="Não há preços cadastrados"
                    :show-empty="true"
                    @row-clicked="handleRowClick"
                  >
                    <template #cell(sort_order)="{ item }">
                      <p>{{ item.sort_order }}</p>
                    </template>
                    <template #cell(cycle_name)="{ item }">
                      <p>{{ item.cycle_name }}</p>
                    </template>
                    <template #cell(cycle_description)="{ item }">
                      <p>{{ item.cycle_description }}</p>
                    </template>
                    <template #cell(instalment_price)="{ item }">
                      <p>{{ formatBRL(item.instalment_price) }}</p>
                    </template>
                    <template #cell(annuity_price)="{ item }">
                      <p>{{ formatBRL(item.annuity_price) }}</p>
                    </template>
                    <template #cell(material_fee)="{ item }">
                      <p>{{ formatBRL(item.material_fee) }}</p>
                    </template>
                    <template #cell(actions)="{ item }">
                      <a
                        @click="() => setDate(item, item.id)"
                        v-b-modal.update-price
                      >
                        <EditIcon />
                      </a>
                    </template>
                  </DataTable>
                </b-col>
                <div class="w-100 mb-5"></div>
              </b-row>

              <ResponsiblePriceView
                :prices="prices"
                :calendar-year="selectedCalendar ? selectedCalendar.name : ''"
              />
            </b-tab>

            <!-- Tab: Pititim -->
            <b-tab title="Pititim">
              <b-row class="mb-3 mt-3">
                <b-col class="text-right">
                  <b-button
                    class="btn large blue"
                    :to="{
                      name: 'precos-pititim-registrar',
                      query: { calendar: selectedCalendar ? selectedCalendar.id : '' },
                    }"
                    >Registrar novo preço</b-button
                  >
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <DataTable
                    :items="pititimPricesList"
                    :fields="pititimTableFields"
                    :busy="!isPititimRequestSend"
                    empty-text="Não há preço Pititim cadastrado"
                    :show-empty="true"
                    @row-clicked="handlePititimRowClick"
                  >
                    <template #cell(price)="{ item }">
                      <p>{{ formatBRL(item.price) }}</p>
                    </template>
                    <template #cell(material_fee)="{ item }">
                      <p>{{ formatBRL(item.material_fee) }}</p>
                    </template>
                    <template #cell(discounts)="{ item }">
                      <div class="discounts-compact">
                        <div class="discounts-compact__row">
                          <span
                            v-for="d in item.discounts"
                            :key="'m-' + d.modules"
                            class="discounts-compact__module"
                          >
                            {{ d.modules }}
                          </span>
                        </div>
                        <div class="discounts-compact__row">
                          <span
                            v-for="d in item.discounts"
                            :key="'d-' + d.modules"
                            class="discounts-compact__value"
                          >
                            {{ d.discount }}%
                          </span>
                        </div>
                      </div>
                    </template>
                    <template #cell(actions)="{ item }">
                      <a
                        v-if="isPititimRequestSend"
                        @click="() => setPititimPrice(item)"
                        v-b-modal.update-pititim-price
                      >
                        <EditIcon />
                      </a>
                    </template>
                  </DataTable>
                </b-col>
                <div class="w-100 mb-5"></div>
              </b-row>

              <PititimPriceView
                :price="pititimPrice"
                :calendar-year="selectedCalendar ? selectedCalendar.name : ''"
              />
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </b-container>
    <UpdatePrice :calendar="selectedDate" />
    <UpdatePititimPrice
      :calendar="selectedCalendar"
      :price="selectedPititimPrice"
    />
  </div>
</template>

<script>
import Moment from "moment";
import EditIcon from "@/components/svg/EditIcon.vue";
import UpdatePrice from "@/components/modals/UpdatePrice.vue";
import UpdatePititimPrice from "@/components/modals/UpdatePititimPrice.vue";
import SidebarCoordination from "@/components/SidebarCoordination.vue";
import DataTable from "@/components/table/DataTable.vue";
import ResponsiblePriceView from "@/components/ResponsiblePriceView.vue";
import PititimPriceView from "@/components/PititimPriceView.vue";
import { formatBRL } from "@/utils/formatBRL";
import httpRda from "../../../http-rda";
import pititimPricesService from "@/services/pititim-prices.service";
import SelectSingle from "../../../components/inputs/SelectSingle.vue";

require("moment/locale/pt-br");
Moment.locale("pt-br");

export default {
  name: "mensalidade-escolar",
  components: {
    EditIcon,
    UpdatePrice,
    UpdatePititimPrice,
    SidebarCoordination,
    SelectSingle,
    DataTable,
    ResponsiblePriceView,
    PititimPriceView,
  },
  data() {
    return {
      activeTab: 0,

      // School prices
      selectedDate: {},
      prices: [],
      isRequestSend: false,
      tableFields: [
        { key: "sort_order", label: "Ordem", thClass: "text-center", tdClass: "text-center" },
        { key: "cycle_name", label: "Nome do ciclo", thClass: "text-center", tdClass: "text-center" },
        { key: "cycle_description", label: "Descrição do ciclo", thClass: "text-center", tdClass: "text-center" },
        { key: "instalment_price", label: "Valor da mensalidade", thClass: "text-center", tdClass: "text-center" },
        { key: "annuity_price", label: "Valor da anuidade", thClass: "text-center", tdClass: "text-center" },
        { key: "material_fee", label: "Taxa de material", thClass: "text-center", tdClass: "text-center" },
        { key: "actions", label: "Editar", thClass: "text-center", tdClass: "text-center" },
      ],

      // Pititim prices
      pititimPrice: null,
      pititimPricesList: [],
      isPititimRequestSend: false,
      pititimRequestId: 0,
      selectedPititimPrice: null,
      pititimTableFields: [
        { key: "price", label: "Preço por módulo", thClass: "text-center", tdClass: "text-center" },
        { key: "material_fee", label: "Taxa de material", thClass: "text-center", tdClass: "text-center" },
        { key: "discounts", label: "Descontos", thClass: "text-center", tdClass: "text-center" },
        { key: "actions", label: "Ações", thClass: "text-center", tdClass: "text-center" },
      ],

      // Shared
      descOrder: false,
      calendars: [],
      selectedCalendar: null,
      selected: null,
      selectedIndex: -1,
      breadcrumb: [
        {
          text: "Secretaria",
          href: "/secretaria",
        },
        {
          text: "Alterações internas",
          active: true,
        },
        {
          text: "Mensalidade escolar",
          href: "/mensalidade-escolar",
          active: true,
        },
      ],
    };
  },
  methods: {
    formatBRL,

    setDate(date) {
      this.selectedDate = date;
    },

    handleRowClick(item) {
      this.selectedIndex = item.id;
    },

    setPititimPrice(item) {
      this.selectedPititimPrice = JSON.parse(JSON.stringify(item));
    },

    handlePititimRowClick(item) {
      this.selectedPititimPrice = JSON.parse(JSON.stringify(item));
    },

    /**
     * Format the discounts array into a compact summary string.
     * Example: "M1: 0% | M2: 25% | M3: 35% ..."
     */
    formatDiscounts(discounts) {
      if (!discounts || !discounts.length) return "-";
      return discounts
        .map((d) => `M${d.modules}: ${d.discount}%`)
        .join(" | ");
    },

    /**
     * Group discounts by percentage and return { discount, count } array.
     */
    groupDiscounts(discounts) {
      if (!discounts || !discounts.length) return [];
      const map = {};
      discounts.forEach((d) => {
        if (!map[d.discount]) {
          map[d.discount] = 0;
        }
        map[d.discount]++;
      });
      return Object.keys(map)
        .sort((a, b) => Number(a) - Number(b))
        .map((key) => ({ discount: Number(key), count: map[key] }));
    },

    async handleCalendar(calendar) {
      this.selectedPititimPrice = null;
      this.selectedCalendar = calendar;
      await Promise.all([
        this.getListPrices(this.selectedCalendar.id),
        this.getPititimPrices(this.selectedCalendar.id),
      ]);
    },

    async getCalendars() {
      const rawCalendars = await httpRda
        .get("/calendars")
        .then((resp) => resp.data.calendars);

      this.calendars = rawCalendars.map((calendar) => {
        return {
          id: calendar.id,
          name: calendar.designation,
        };
      });

      const enrollmentCalendar = rawCalendars.find(
        (calendar) => calendar.enrollment
      );
      const currentCalendar = rawCalendars.find(
        (calendar) => calendar.current
      );
      const preselected = enrollmentCalendar || currentCalendar;

      this.selectedCalendar = preselected
        ? { id: preselected.id, name: preselected.designation }
        : null;

      if (!this.selectedCalendar) {
        const currentYear = new Date().getFullYear();
        this.selectedCalendar = this.calendars.find(
          (calendar) => calendar.name == currentYear
        );
      }

      await this.loadAllPrices(this.selectedCalendar.id);
    },

    async loadAllPrices(calendarId) {
      await Promise.all([
        this.getListPrices(calendarId),
        this.getPititimPrices(calendarId),
      ]);
    },

    async getListPrices(calendarId) {
      const params = {};

      params.calendar_id = calendarId ? calendarId : null;

      await httpRda
        .get("/prices", { params })
        .then((response) => {
          this.prices = response.data.prices.values;
          this.isRequestSend = true;
        })
        .catch((error) => {
          return error;
        });
    },

    async getPititimPrices(calendarId) {
      const requestId = ++this.pititimRequestId;

      this.isPititimRequestSend = false;
      this.selectedPititimPrice = null;
      this.pititimPricesList = [];
      this.pititimPrice = null;

      await pititimPricesService
        .getAll({ calendar_id: calendarId })
        .then((response) => {
          if (requestId !== this.pititimRequestId) {
            return;
          }

          const price = response.data.price;
          // API returns { price: null } when no price exists, or the price object
          this.pititimPricesList = price ? [price] : [];
          this.pititimPrice = price;
          this.isPititimRequestSend = true;
        })
        .catch(() => {
          if (requestId !== this.pititimRequestId) {
            return;
          }

          this.pititimPricesList = [];
          this.pititimPrice = null;
          this.isPititimRequestSend = true;
        });
    },
  },

  created() {
    this.getCalendars();
    const savedTab = localStorage.getItem("prices-active-tab");
    if (savedTab !== null) {
      this.activeTab = parseInt(savedTab, 10);
    }
  },

  computed: {},

  watch: {
    activeTab(value) {
      localStorage.setItem("prices-active-tab", value);
    },
  },

  filters: {
    formatDate(value) {
      return Moment(value).format("DD/MM/YYYY");
    },
    formatDateYear(value) {
      return Moment(value).format("YYYY");
    },
    formatLanguage(value) {
      return Moment(value).format("dddd");
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/css/variables.scss";

.home {
  height: 100%;
}

.container-rda {
  padding-bottom: 0;
}

// Tab styling to match the purple theme
.pititim-tabs {
  .nav-tabs {
    border-bottom: 2px solid #e7e8ec;

    .nav-link {
      color: $grey4;
      font-weight: 600;
      font-size: 16px;
      border: none;
      padding: 12px 24px;
      border-bottom: 3px solid transparent;
      margin-bottom: -2px;
      transition: color 0.2s, border-color 0.2s;

      &:hover {
        color: $purple;
        border-color: transparent;
      }

      &.active {
        color: $purple;
        background-color: transparent;
        border-bottom-color: $purple;
      }
    }
  }
}

.discounts-summary {
  font-size: 13px;
  line-height: 1.4;
  word-break: break-word;
}

.discounts-compact {
  display: inline-flex;
  flex-direction: column;
  font-size: 11px;
  line-height: 1.4;
  text-align: center;

  &__row {
    display: flex;
    gap: 0;
  }

  &__module,
  &__value {
    display: inline-block;
    width: 36px;
    padding: 1px 2px;
    text-align: center;
  }

  &__value {
    margin-left: 0.5px;
  }

  &__module {
    color: $purple;
    font-weight: 700;
    border-bottom: 1px solid $grey5;
  }

  &__value {
    color: $grey3;
    font-weight: 600;
  }
}
</style>
